

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getNotificationCategoryCounts
// GETNOTIFICATIONCATEGORYCOUNTS   
const GETNOTIFICATIONCATEGORYCOUNTS= createAsyncThunk(
  "getNotificationCategoryCounts/getNotificationCategoryCounts",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getNotificationCategoryCountsSlice = createSlice({
  name: "getNotificationCategoryCountsSlice",
  initialState: {
    getNotificationCategoryCounts: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetNotificationCategoryCounts: (state) => {
        state.getNotificationCategoryCounts.loading = false
        state.getNotificationCategoryCounts.error = false
        state.getNotificationCategoryCounts.data = []
        state.getNotificationCategoryCounts.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETNOTIFICATIONCATEGORYCOUNTS.fulfilled, (state, action) => {
      state.getNotificationCategoryCounts = {
        ...state.getNotificationCategoryCounts,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETNOTIFICATIONCATEGORYCOUNTS.pending, (state, action) => {
      state.getNotificationCategoryCounts = {
        ...state.getNotificationCategoryCounts,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETNOTIFICATIONCATEGORYCOUNTS.rejected, (state, action) => {
      state.getNotificationCategoryCounts = {
        ...state.getNotificationCategoryCounts,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getNotificationCategoryCountsAction = {
    GETNOTIFICATIONCATEGORYCOUNTS,
};

export { getNotificationCategoryCountsAction };
export default getNotificationCategoryCountsSlice.reducer;
export const {setInitialStateOfgetNotificationCategoryCounts} = getNotificationCategoryCountsSlice.actions